module.exports = __webpack_public_path__ + "img/gate_full.9225f7df.jpg";